@switch (type()) {
    @case ('h1') {
        <h1
            [class]="'font-[600] text-gray-800 dark:text-gray-200 md:text-xl text-2xl ' + additionalClasses()"
            [ngClass]="{ 'text-center': text() === 'center' }"
        >
            {{ content() }}
        </h1>
    }

    @case ('h2') {
        <h2
            [class]="'font-[600] text-1xl text-gray-800 dark:text-gray-200 md:text-lg ' + additionalClasses()"
            [ngClass]="{ 'text-center': text() === 'center' }"
        >
            {{ content() }}
        </h2>
    }

    @case ('h3') {
        <h3
            [class]="'font-[600] text-gray-800 dark:text-gray-200 text-lg ' + additionalClasses()"
            [ngClass]="{ 'text-center': text() === 'center' }"
        >
            {{ content() }}
        </h3>
    }

    @case ('h4') {
        <h4
            [class]="'font-[600] text-gray-800 dark:text-gray-200 text-md md:text-xs ' + additionalClasses()"
            [ngClass]="{ 'text-center': text() === 'center' }"
        >
            {{ content() }}
        </h4>
    }
}

@if (subheading() !== '') {
    <p [ngClass]="{ 'text-center': text() === 'center' }" class="text-gray-400 dark:text-gray-400">
        {{ subheading() }}
    </p>
}

@if (divider()) {
    <div class="md:pt-2">
        <p-divider />
    </div>
}
